// src/encounter/lib/medication-dose-line.ts
// ONE derivation of a summary medication's "dose — frequency — route" line, for every surface that
// shows it (the chart rail, the pre-visit Active Medications list, the social/med rail). Three
// hand-copied versions of it each joined the route with String(); on the GetPatientSummary wire the
// route is a coded object ({ system, code, display }) for meds written by the React app, so all
// three rendered "[object Object]" on dev (1 Oct).
import type { PatientMedication, SummaryCode } from '@/types/patient-summary-api';
import { clinicalDisplayName } from '@/lib/clinical-display-name';

/** The route as display text: a string is trimmed, a code reads display || displayName || code. */
export function medicationRouteText(route: string | SummaryCode | null | undefined): string {
  if (typeof route === 'string') return route.trim();
  return clinicalDisplayName(route).name;
}

/** "500 mg — BID — Oral". A zero amount is a placeholder and is skipped; empty parts drop out. */
export function medicationDoseLine(m: PatientMedication): string | undefined {
  const amt = m.amount?.value;
  const dose = amt && Number(amt) !== 0 ? `${amt} ${m.unitOfMeasurement || m.amount?.unit || ''}`.trim() : '';
  const parts = [dose, m.frequency, medicationRouteText(m.route)].filter((p) => p && String(p).trim());
  return parts.length ? parts.join(' — ') : undefined;
}
